// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"367":"d5cd8e25edf8187dcef0","809":"1d0d9759f59c4bda20c2"}[chunkId] + ".chunk.js";
};